<template>
    <div class="content">
        <div class="cont">
            <div class="headimg">
                <img class="imgs" src="../../image/bj2.png" alt="">
            </div>

        </div>
        <div class="conts">
            <div class="head_cont">
                <div class="left">
                    <!-- <div class="contbor">
                        <p>扫码关注平台公众号</p>
                        <img src="../../image/wxgzh.png" width="110" height="110" style="margin: 10px 0;" alt="">
                        <p>微信公众号</p>
                    </div> -->
                    <div class="contbor">
                        <p>扫码访问移动端网页</p>
                        <img src="../../image/sjwz.png" width="110" height="110" style="margin: 10px 0;" alt="">
                        <p>手机网站</p>
                    </div>
                    <div class="contbor">
                        <p>扫码进入平台小程序</p>
                        <img src="../../image/wxxcx.png" width="110" height="110" style="margin: 10px 0;" alt="">
                        <p>微信小程序</p>
                    </div>
                </div>
                <div class="right">
                    <p>苏州铭顺网络信息技术有限公司旗下网站</p>
                    <p>服务热线：0512-67229277 苏州专业的商铺租售信息发布平台</p>
                    <p>Copyright © 2010-2019 铭顺商铺网 www.51mingshun.com, All Rights Reserved</p>
                    <div class="yqtx">友情推荐：</div>
                    <div class="find">
                        <span v-for="(item, index) of footList " :key="index">{{ item.name }}</span>
                    </div>
                </div>
            </div>
            <div class="solid"></div>
            <div class="btm_cont">
                <ul class="btm_men">
                    <li>
                        <router-link to="/">网站首页</router-link>
                    </li>
                    <li>
                        <router-link to="/">会员服务</router-link>
                    </li>
                    <li>
                        <router-link to="/">广告投放</router-link>
                    </li>
                    <li>
                        <router-link to="/">关于铭顺</router-link>
                    </li>
                    <li>
                        <router-link to="/">通知公告</router-link>
                    </li>
                    <li>
                        <router-link to="/">企业文化</router-link>
                    </li>
                    <li>
                        <router-link to="/">联系铭顺</router-link>
                    </li>
                </ul>
            </div>
            <div class="ba">苏ICP备2020048660号  ICP经营许可证号：苏B2-20140271  苏公网安备32050802012457号</div>
        </div>
    </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {
            footList: [
                { name: '苏州厂房网' },
                { name: '赶集网' },
                { name: '易登网' },
                { name: '丁丁网' },
                { name: '58同城' },
                { name: '美团' },
                { name: '阿里巴巴' },
                { name: '百度' }
            ]
        };
    },
    created() {

    },
    mounted() {

    },
    methods: {

    },
}
</script>
<style scoped lang='less'>
.content {
    width: 100%;
    min-width: 1200px;
    height: 360px;
    
}

.cont {
    width: 100%;
    background: #E8F2FE;
    border-radius: 0px 0px 0px 0px;

    .headimg {
        width: 100%;
        height: 100px;

        .imgs {
            width: 100%;
            height: 100%;
        }
    }
}

.conts {
    width: 100%;
    height: 450px;
    background: #1B1B1B;
    border-radius: 0px 0px 0px 0px;
    display: flow-root;
    cursor: pointer;
    .head_cont {
        width: 1200px;
        height: 180px;
        margin: 50px auto;
        display: flex;
        // align-items: center;

        .left {
            display: flex;
            align-items: center;
            width: 50%;
            justify-content: space-evenly;
            border-right: 1px solid rgba(255, 255, 255, 0.5);

            .contbor {
                text-align: center;
                p {
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;
                    margin: 0;
                    padding: 0;
                }
            }
        }

        .right {
            width: 50%;
            text-align: left;
            margin-left: 50px;

            p {
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                padding: 0;
                margin: 0 0 10px 0;
            }

            .yqtx {
                font-weight: bold;
                font-size: 14px;
                color: #FFFFFF;
                margin-top: 10px;
            }

            .find {
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 10px;
            }
        }
    }

    .solid {
        width: 1000px;
        height: 0px;
        border: 1px solid rgba(255, 255, 255, 0.5);
        margin: 0 auto;
    }

    .btm_cont {
        width: 750px;
        margin: 30px auto;

        ul {
            display: flex;
            align-items: center;
            justify-content: space-evenly;
           li{
            padding: 0 20px;
            list-style: none;
            border-right: 1px solid rgba(255,255,255,0.6);;
           }
            a {
                font-weight: 400;
                font-size: 12px;
                color: #FFFFFF;
                text-decoration: none;
            }
        }
        ul>li:nth-child(7) {
            border: none;
        }
    }
    .ba{
        font-weight: 400;
font-size: 12px;
color: #FFFFFF;
text-align: center;
    }

}</style>